import styles from './WeekDays.module.scss';
import { memo } from 'react';
import Typography from '@/components/UI/typography/Typography';
import Box from '@/components/UI/box/Box';
import { getDaysLabels } from '@/helpers/dateManager';
const WeekDays = ({
  fullWidth = false
}) => {
  return <Box className={`${styles['date-picker-days']} ${fullWidth ? styles['full-width'] : ''}`} data-sentry-element="Box" data-sentry-component="WeekDays" data-sentry-source-file="WeekDays.tsx">
      {getDaysLabels('JALALI').map((item, index) => <Typography variant="bodyL_Bold" key={index} className={styles['day-label']}>
          {item}
        </Typography>)}
    </Box>;
};
export default memo(WeekDays);